export default __webpack_public_path__ + "static/media/(27).1e834f5c.jpeg";